<template>
  <div v-if="haveUser">
    <template v-if="onDefaultProfileView">
      <div class="dashboard-page-title">
        <div class="container-fluid">
          <h1>Profile</h1>
        </div>
      </div>

      <div class="container-fluid">
        <profile-vlast-privacy-policy v-if="$vlastMode && $user.id === user.id"/>
        <profile-onboarding-video v-if="$userIsAdmin && userIsTalent && user.profile && user.profile.onboarding_video_link" :user="user"/>
        <profile-social-sharing v-if="userIsTalent && !$vlastMode && user.status === 'active' && user.profile && user.profile.visibility === 'public'"/>
        <profile-manager-counts v-if="userIsMasterManager && $userIsAdmin"/>

        <profile-talent-section v-if="userIsTalent"/>

        <profile-account-details v-if="showAccountDetails"/>
        <profile-additional-details v-if="showAccountDetails && user.custom_fields"/>

        <profile-payment-details-section v-if="showPaymentDetails"/>

        <profile-change-password v-if="!$userIsIntern && this.$user.role !== 'sales' && userIsActive && !this.userIsRestrictedAdminAndPermissionIsEnabled"/>

        <profile-card-details-section v-if="user.id == $user.id" />

        <profile-contracts v-if="$talentContractsModuleEnabled && userIsActive && user.contracts && user.contracts.length"/>

        <profile-date-time-preferences v-if="!(userIsClient && clientName === 'GSE')"/>

        <ul class="item-detail item-detail-simple" v-if="!userIsTalent && userIsActive">
          <li>
            <router-link :to="{ name: `${ $route.name }.images`, params: { id: user.id } }">
              <div class="row">
                <div class="col-xs-8">
                  <h3 class="has-sub">Profile Image</h3>
                  <p class="sub-text">Upload a profile image to be used across the site</p>
                </div>
                <div class="col-xs-4">
                  <div class="actions pull-right">
                  <span class="btn btn-info">
                    <i class="fa fa-pencil"></i>
                  </span>
                  </div>
                </div>
              </div>
            </router-link>
          </li>
        </ul>

        <profile-market-segment v-if="($userIsAdmin || $userIsIntern) && userIsClientAndActiveClientModuleEnabled"/>

        <profile-talent-visibility-options v-if="($userIsAdmin || $userIsIntern) && userIsTalent && !$vlastMode"/>

        <profile-talent-scores v-if="!$vlastMode && $userIsAdmin && userIsTalent"/>

        <profile-talent-management-options v-if="userIsTalent && ($userIsAdmin || $userIsMasterManager) && $managerModuleEnabled"/>

        <profile-manager-management-options v-if="userIsMasterManager && $userIsAdmin && $paymentsModuleEnabled"/>

        <profile-club-form v-if="showAccountDetails && !$userIsAdmin"/>

        <profile-manager-staff v-if="userIsMasterManager"/>

        <profile-talent-bookings
          v-if="(($userIsAdmin || $userIsIntern || $userIsManager) && userIsTalent)  || $userIsTalent"
          :talent="user"/>

        <profile-notes :talent="user" v-if="user.id && userIsTalent && $userIsAdmin && !$vlastMode" />

        <profile-account-actions v-if="userIsActive || $vlastMode"/>

        <profile-privacy-data v-if="!$vlastMode"/>

      </div>
    </template>
    <template v-else>
      <router-view/>
    </template>
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import { notify } from 'utils'
import { helpers } from 'mixins/users'
import ProfileAccountDetails from './ProfileAccountDetails'
import ProfileAdditionalDetails from './ProfileAdditionalDetails'
import ProfileAccountActions from './ProfileAccountActions'
import ProfileTalentSection from './ProfileTalentSection'
import ProfilePaymentDetailsSection from './ProfilePaymentDetailsSection'
import ProfileCardDetailsSection from './ProfileCardDetailsSection'
import ProfileChangePassword from './ProfileChangePassword'
import ProfileTalentVisibilityOptions from './ProfileTalentVisibilityOptions'
import ProfileTalentManagementOptions from './ProfileTalentManagementOptions'
import ProfileManagerManagementOptions from './ProfileManagerManagementOptions'
import ProfileManagerStaff from './ProfileManagerStaff'
import ProfileManagerCounts from './ProfileManagerCounts'
import ProfileTalentBookings from './ProfileTalentBookings'
import ProfileMarketSegment from './ProfileMarketSegment'
import ProfileTalentScores from './ProfileTalentScores'
import ProfileContracts from './ProfileContracts'
import ProfileClubForm from './ProfileClubForm'
import ProfilePrivacyData from './ProfilePrivacyData'
import ProfileDateTimePreferences from './ProfileDateTimePreferences'
import ProfileSocialSharing from './ProfileSocialSharing'
import ProfileNotes from './ProfileNotes'
import ProfileVlastPrivacyPolicy from './ProfileVlastPrivacyPolicy'
import ProfileOnboardingVideo from './ProfileOnboardingVideo'

export default {
  mixins: [helpers],

  props: ['id'],

  components: {
    ProfileOnboardingVideo,
    ProfileSocialSharing,
    ProfileClubForm,
    ProfileAccountDetails,
    ProfileAdditionalDetails,
    ProfileAccountActions,
    ProfileTalentSection,
    ProfilePaymentDetailsSection,
    ProfileCardDetailsSection,
    ProfileChangePassword,
    ProfileTalentManagementOptions,
    ProfileTalentVisibilityOptions,
    ProfileManagerManagementOptions,
    ProfileManagerStaff,
    ProfileManagerCounts,
    ProfileTalentBookings,
    ProfileMarketSegment,
    ProfileTalentScores,
    ProfileDateTimePreferences,
    ProfilePrivacyData,
    ProfileContracts,
    ProfileNotes,
    ProfileVlastPrivacyPolicy
  },

  computed: {
    ...mapState('user', ['user']),
    ...mapGetters('user', ['haveUser']),

    onDefaultProfileView () {
      return new RegExp(/^([a-z]+\.)*profile\.show$/).test(this.$route.name)
    },

    showPaymentDetails () {
      if (!this.$paymentDetails) {
        return false
      }
      if (typeof this.user.payment_details !== 'undefined') {
        return true
      }
      return false
    },

    showAccountDetails () {
      if (typeof this.user.email !== 'undefined' && !this.userIsRestrictedAdminAndPermissionIsEnabled) {
        return true
      }
      return false
    },

    userIsClientAndActiveClientModuleEnabled () {
      return this.user.role === 'client' && this.$activeClientModuleEnabled
    },

    userIsActive () {
      return this.user.role !== 'client' || this.userIsClientAndActiveClientModuleEnabled
    },

    userIsRestrictedAdminAndPermissionIsEnabled () {
      if (this.user.role === 'manager' || this.user.role === 'client') {
        return false
      } else if (this.$user.role === 'restricted-admin' && this.$user.id === this.user.id) {
        return false
      }
      return this.$user.role === 'restricted-admin' && this.$restrictedAdminPermission
    }
  },

  watch: {
    id (oldValue, newValue) {
      if (parseInt(oldValue) === parseInt(newValue)) {
        return
      }

      let id = this.id || this.$user.id

      this.getUser({ id })
    }
  },

  beforeDestroy () {
    this.resetUser()
  },

  created () {
    this.$validator.reset()

    let id = this.id || this.$user.id

    this.getUser({ id })
      .catch((error) => {
        if (error.response && error.response.status === 404) {
          notify.error('Could not find the user.')

          this.$router.push({ name: 'dashboard', query: { src: 'profile' } })
        }
      })
  },

  methods: {
    ...mapActions('user', ['getUser', 'resetUser'])
  }
}
</script>
